import ReactECharts from "echarts-for-react";

export type BarChartProps = {
  options?: any;
};

const BarChart = ({ options }: BarChartProps) => {
  const tooltipFormatter = (params?: any) => {
    const { seriesName, value } = params;
    return `        
            <div style="display: flex; align-items: center;">
              <span>${seriesName} :<br/>${value}</span>
            </div>
          `;
  };

  // Default options
  const defaultOptions = {
    tooltip: {
      formatter: tooltipFormatter,
      backgroundColor: "var(--mui-palette-primary-main)", // Custom background color
      extraCssText: "color: var(--mui-palette-primary-contrastText); padding: 4px 8px; border: 0",
    },
    xAxis: {
      type: "category",
      axisLabel: {
        color: "var(--mui-palette-primary-main)",
        fontSize: 14,
        fontFamily: "Inter",
        fontWeight: 400,
      },
      axisLine: {
        show: false, // Hide the x-axis line
      },
      axisTick: {
        show: false, // Hide the x-axis ticks
      },
      offset: 16,
    },
    yAxis: {
      type: "value",
      axisLine: {
        show: false, // Hide the y-axis line
      },
      axisTick: {
        show: false, // Hide the y-axis ticks
      },
      axisLabel: {
        show: false, // Hide the y-axis labels
      },
    },
    series: [],
  };

  // Merge the default options with the provided options (if any)
  const mergedOptions = {
    ...defaultOptions,
    ...options,
    xAxis: {
      ...defaultOptions.xAxis,
      ...options?.xAxis,
    },
    yAxis: {
      ...defaultOptions.yAxis,
      ...options?.yAxis,
    },
    series: options?.series?.map((userSeries: any, index: any) => ({
      ...(defaultOptions.series[index] as object), // Use default options for the first bar
      ...userSeries,
    })),
  };

  return (
    <ReactECharts
      option={mergedOptions}
      style={{ height: "250px", width: "100%" }}
      opts={{ renderer: "svg" }}
    />
  );
};

export default BarChart;
